import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row-vcenter" }
const _hoisted_2 = ["src", "alt", "title"]
const _hoisted_3 = {
  key: 0,
  class: "info"
}
const _hoisted_4 = {
  key: 0,
  class: "skeleton"
}
const _hoisted_5 = {
  key: 1,
  class: "text"
}
const _hoisted_6 = {
  key: 0,
  class: "error"
}
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "size" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["initials no-select", {pulse: $options.loading, error: !!$options.image.error}])
    }, [
      _createCommentVNode(" \n          IMG tag ignores CORS rules, so Origin header is not sent to the server and s3\n          doesn't return CORS headers. Browser caches the response. When making pdf \n          images are requested using XMLHTTPRequest that requires CORS but cached \n          response doesn't include CORS headers and request fails. crossoringin='anonymous'\n          forces browser to send Origin header for this image. This option is not necessary\n          if image would not be requested using XMLHTTPRequest later.\n    "),
      ($options.avatar_url)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: $options.avatar_url,
            alt: $props.name,
            title: $props.name,
            crossorigin: "anonymous"
          }, null, 8 /* PROPS */, _hoisted_2))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString($options.initials), 1 /* TEXT */)
          ], 64 /* STABLE_FRAGMENT */))
    ], 2 /* CLASS */),
    ($props.showInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          ($options.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[0] || (_cache[0] = [
                _createElementVNode("div", {
                  style: {"width":"8.8rem"},
                  nowrap: ""
                }, null, -1 /* HOISTED */),
                _createElementVNode("div", {
                  style: {"width":"4.9rem"},
                  nowrap: ""
                }, null, -1 /* HOISTED */)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (!!$options.image.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Failed to load avatar "))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString($options.image.name), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$utils.format.bytes($options.image.size)), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
              ]))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}